import React from 'react';
import '../styles/familyTree.css';

const FamilyTree = () => {
  return (
    <div className="family-tree-container">
      <div className="family-tree-content">
        <h1>Aarush Agrawal</h1>
        <div className="subtitle">Family Tree</div>
        
        {/* Distant Ancestry Section */}
        <div className="tree-section">
          <div className="section-title">1. Distant Ancestry - The Agrawal Heritage</div>
          
          <div className="ancient-section">
            <div className="ancient-box">
              👑 King Agrasen<br />
              <span style={{ fontSize: '0.7em' }}>(circa 3000-5000 years ago)</span>
            </div>
            
            <div className="ancient-text">
              <p><strong>The name "Agrawal" literally means "descendants of King Agrasen"</strong> - an ancient Indian king known for establishing a prosperous kingdom based on principles of trade and equality.</p>
              
              <p>King Agrasen had <strong>18 sons</strong>, each founding a different gotra (clan) within the Agrawal community. Aarush's family connects to this ancient lineage through two of these sons:</p>
              
              <p>🏛️ <strong>Goel clan</strong> - Mother's side (founded by one of King Agrasen's sons)<br />
              🏛️ <strong>Mangal clan</strong> - Father's side (founded by another son)</p>
              
              <p style={{ marginTop: '20px', fontStyle: 'italic' }}>Through thousands of years, these family lines have preserved their identity and heritage, passing down traditions and values from one generation to the next.</p>
            </div>
          </div>
        </div>
        
        {/* Recent Ancestry Section */}
        <div className="tree-section">
          <div className="section-title">2. Recent/Direct Ancestry</div>
          
          {/* Current Generation - Aarush at TOP */}
          <div className="current-generation">
            <div className="person-box current" style={{ display: 'inline-block' }}>
              <div className="person-name">Aarush Agrawal</div>
              <div className="person-role">Current Generation</div>
            </div>
          </div>
          
          {/* Diverging arrows UP to both parents */}
          <div className="converge-container">
            <div className="converge-line center-vertical-down"></div>
            <div className="converge-line left-diagonal-down"></div>
            <div className="converge-line right-diagonal-down"></div>
          </div>
          
          {/* Two Branches Side by Side */}
          <div className="arrow-tree-container">
            {/* Father's Side */}
            <div className="family-branch">
              <div className="branch-header">👨 Father's Side (Mangal/Gupta)</div>
              
              <div className="person-box">
                <div className="person-relation">(Father)</div>
                <div className="person-name">Gaurav Gupta</div>
                <div className="person-role">Software Engineer</div>
              </div>
              
              <div className="upward-arrow">
                <div className="arrow-head-up"></div>
                <div className="arrow-line-up"></div>
              </div>
              
              <div className="person-box">
                <div className="person-relation">(Grandfather)</div>
                <div className="person-name">Rishipal Gupta</div>
                <div className="person-role">Businessman</div>
              </div>
              
              <div className="upward-arrow">
                <div className="arrow-head-up"></div>
                <div className="arrow-line-up"></div>
              </div>
              
              <div className="person-box">
                <div className="person-relation">(Great-Grandfather)</div>
                <div className="person-name">Mitra Sen Mangal</div>
                <div className="person-role">Landlord</div>
              </div>
              
              <div className="upward-arrow">
                <div className="arrow-head-up"></div>
                <div className="arrow-line-up"></div>
              </div>
              
              <div className="person-box">
                <div className="person-relation">(Great-Great-Grandfather)</div>
                <div className="person-name">Raghu Prasad Mangal</div>
                <div className="person-role">Landlord</div>
              </div>
              
              <div className="upward-arrow">
                <div className="arrow-head-up"></div>
                <div className="arrow-line-up"></div>
              </div>
              
              <div className="person-box">
                <div className="person-relation">(3× Great-Grandfather)</div>
                <div className="person-name">Badriprasad Mangal</div>
                <div className="person-role">Landlord</div>
              </div>
              
              <div className="upward-arrow">
                <div className="arrow-head-up"></div>
                <div className="arrow-line-up"></div>
              </div>
              
              <div className="person-box">
                <div className="person-relation">(4× Great-Grandfather)</div>
                <div className="person-name">Mukha Mangal</div>
                <div className="person-role">Landlord (lived around 1820s)</div>
                <div className="person-role"><u style={{ fontWeight: "bolder", fontStyle: "normal" }}>Fun fact</u>: Established family farms in 1857</div>
              </div>
            </div>
            
            {/* Mother's Side */}
            <div className="family-branch">
              <div className="branch-header">👩 Mother's Side (Goel)</div>
              
              <div className="person-box">
                <div className="person-relation">(Mother)</div>
                <div className="person-name">Tulika Goel</div>
                <div className="person-role">Software Engineer</div>
              </div>
              
              <div className="upward-arrow">
                <div className="arrow-head-up"></div>
                <div className="arrow-line-up"></div>
              </div>
              
              <div className="person-box">
                <div className="person-relation">(Grandfather)</div>
                <div className="person-name">Satish Goel</div>
                <div className="person-role">Businessman</div>
              </div>
              
              <div className="upward-arrow">
                <div className="arrow-head-up"></div>
                <div className="arrow-line-up"></div>
              </div>
              
              <div className="person-box">
                <div className="person-relation">(Great-Grandfather)</div>
                <div className="person-name">Lachiram Goel</div>
                <div className="person-role">Landlord</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyTree;
